import firebase from "../firebase";

export default function({ officeId, senderId, conversationId, message }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "createMessage",
        data: { officeId, senderId, conversationId, message }
    });
}
